import React from "react";

export default function WeeklyNewsletter() {
  return (
    <div className="portfoliofooterright">
      <h6>Weekly News</h6>
      <p>
        Stay up to date on releases and business tips by joining our newsletter.
        By subscribing, you agree to our Privacy Policy.
      </p>
      <div className="footerinputdiv">
        <input type="text" placeholder="Your Email" />
        <button>Subscribe</button>
      </div>
    </div>
  );
}
